import React, { useEffect, useState } from "react";
import { View, Image, StyleSheet } from "react-native";

import IconTouchable from "./IconTouchable";

import config from "../config/config";
import ListItemSeperator from "./lists/ListItemSeperator";
import AppText from "./AppText";

function Selector({
    value1,
    value2,
    value3,
    value4,
    value5,
    onChange,
    title,
    icon1,
    icon2,
    icon3,
    icon4,
    icon5,
    textValue1,
    textValue2,
    textValue3,
    textValue4,
    textValue5,
    startingValue,
}) {
    const [selectedValue, setSelectedValue] = useState(startingValue ? startingValue : value1);

    return (
        <View>
            <View style={styles.component}>
                <View style={styles.title}>
                    <AppText>{title}</AppText>
                </View>
                <View style={styles.selector}>
                    <IconTouchable
                        name={icon1}
                        text={textValue1 ? textValue1 : value1}
                        textColor={config.colors.black}
                        onPress={() => {
                            setSelectedValue(value1);
                            onChange(value1);
                        }}
                        borderColor={selectedValue == value1 ? config.colors.green : config.colors.silver}
                    />
                    {value2 && (
                        <IconTouchable
                            name={icon2}
                            text={textValue2 ? textValue2 : value2}
                            textColor={config.colors.black}
                            onPress={() => {
                                setSelectedValue(value2);
                                onChange(value2);
                            }}
                            borderColor={selectedValue == value2 ? config.colors.green : config.colors.silver}
                        />
                    )}
                    {value3 && (
                        <IconTouchable
                            name={icon3}
                            text={textValue3 ? textValue3 : value3}
                            textColor={config.colors.black}
                            onPress={() => {
                                setSelectedValue(value3);
                                onChange(value3);
                            }}
                            borderColor={selectedValue == value3 ? config.colors.green : config.colors.silver}
                        />
                    )}
                    {value4 && (
                        <IconTouchable
                            name={icon4}
                            text={textValue4 ? textValue4 : value4}
                            textColor={config.colors.black}
                            onPress={() => {
                                setSelectedValue(value4);
                                onChange(value4);
                            }}
                            borderColor={selectedValue == value4 ? config.colors.green : config.colors.silver}
                        />
                    )}
                    {value5 && (
                        <IconTouchable
                            name={icon5}
                            text={textValue5 ? textValue5 : value5}
                            textColor={config.colors.black}
                            onPress={() => {
                                setSelectedValue(value5);
                                onChange(value5);
                            }}
                            borderColor={selectedValue == value5 ? config.colors.green : config.colors.silver}
                        />
                    )}
                </View>
            </View>
            <View>
                <ListItemSeperator />
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    selector: {
        flexDirection: "row",
        justifyContent: "space-around",
        paddingTop: 10,
    },
    component: {
        paddingVertical: 10,
        backgroundColor: config.colors.white,
    },
    title: {
        alignItems: "center",
    },
});

export default Selector;
